/* src/app/shared/components/ag-textarea/ag-textarea.component.scss */
.textarea-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 314px;
  position: relative;
}
.textarea {
  background-color: #f2f2f2;
  border: 1px solid transparent;
  position: relative;
  height: auto;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  overflow: visible;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}
.textarea-focused {
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  position: relative;
  height: auto;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  overflow: visible;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}
textarea::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #5c5c5c;
}
.input {
  max-height: 120px;
  width: 97%;
  border: none;
  outline: none;
  float: right;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
  scrollbar-width: none;
  resize: none;
  min-height: 24px;
  font-family: "Poppins-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  cursor: text;
}
.input-focused {
  max-height: 120px;
  width: 97%;
  border: none;
  outline: none;
  float: right;
  font-size: 14px;
  border: none;
  background-color: #ffffff;
  scrollbar-width: none;
  resize: none;
  min-height: 24px;
  font-family: "Poppins-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  cursor: text;
}
input:focus {
  outline: none;
}
.sendIcon {
  width: 18px;
  height: 18px;
  filter: brightness(0) saturate(100%) invert(60%) sepia(97%) saturate(1930%) hue-rotate(198deg) brightness(89%) contrast(91%);
  opacity: 0.5;
}
.sendIconError {
  width: 18px;
  height: 18px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
  opacity: 0.5;
}
.bottom-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.bottom-container .info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
.bottom-container .info-container .info-img {
  height: 12px;
  width: 12px;
}
.bottom-container .info-container .error-img {
  height: 12px;
  width: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.bottom-container .info-container .info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
.bottom-container .chars {
  font-family: "Poppins-Regular";
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #a6a6a6;
  align-self: flex-end;
  display: flex;
}
.delete-button {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e55e5e;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  border: 1px solid transparent;
}
.delete-button img {
  filter: brightness(0) invert(1);
}
.delete-button:hover {
  opacity: 0.8;
}
.personalised-tag {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  position: absolute;
  top: 12px;
  cursor: pointer;
  border: 1px solid transparent;
}
.personalised-tag-open {
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
}
.personalised-tag:hover {
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
}
.personalised-tag-dropdown {
  position: absolute;
  top: 46px;
  right: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 400px;
  align-items: center;
  background-color: #ffffff;
  transition: height 0.3s ease-in-out;
  border-radius: 12px;
  overflow: hidden;
  z-index: 10;
}
.personalised-tag-dropdown .drop-down-header {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  border-bottom: 1px solid #dfdfdf;
}
.personalised-tag-dropdown .drop-down-footer {
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  border-top: 1px solid #dfdfdf;
}
.personalised-tag-dropdown .drop-down-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  width: 100%;
  border-bottom: 1px solid #dfdfdf;
  background-color: #f2f2f2;
}
.personalised-tag-dropdown .drop-down-search input {
  outline: none;
  border: none;
  width: 100%;
  background-color: transparent;
}
.personalised-tag-dropdown .drop-down-list {
  display: flex;
  flex-direction: column;
  overflow: scroll;
}
.personalised-tag-dropdown .drop-down-list .no-border {
  border: none !important;
}
.personalised-tag-dropdown .drop-down-list .list-item {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  cursor: pointer;
}
.personalised-tag-dropdown .drop-down-list .list-item:hover {
  opacity: 0.8;
}
.personalised-tag-dropdown .hide-or-replace {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.personalised-tag-dropdown .hide-or-replace .replace-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 12px;
}
.personalised-tag-dropdown .hide-or-replace .replace-row img {
  cursor: pointer;
  height: 20px;
  width: 20px;
}
.personalised-tag-dropdown .hide-or-replace .text-button {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.personalised-tag-dropdown .hide-or-replace .or-divider {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.personalised-tag-dropdown .hide-or-replace .or-divider .half-divider {
  width: 50%;
  height: 1px;
  background: #dfdfdf;
}
.personalised-tag-dropdown .hide-or-replace .or-divider h4 {
  width: 36px;
  background: #ffffff;
  text-align: center;
  color: #5c5c5c;
}
.personalised-tag-dropdown-shown {
  border: 1px solid #dfdfdf;
  box-shadow: 1px 2px 10px 0px rgba(34, 34, 34, 0.1);
}
/*# sourceMappingURL=ag-textarea.component.css.map */
